import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#0B2545] text-white shadow-sm hover:bg-[#081C36]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-[#0B2545]/25 bg-white text-[#0B2545] shadow-sm hover:bg-[#0B2545]/5 hover:border-[#0B2545]/50",
        secondary:
          "bg-[#FFC107] text-[#0B2545] shadow-sm hover:bg-[#E6AD06]",
        gold:
          "bg-[#FFC107] text-[#0B2545] shadow-sm hover:bg-[#E6AD06]",
        ghost: "text-[#0B2545] hover:bg-[#0B2545]/5",
        link: "text-[#0B2545] underline-offset-4 decoration-[#FFC107] decoration-2 hover:underline hover:text-[#FF5722]",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
